import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { listStyles } from "@dana/Overrides/Widgets/MyLists/MyListsList";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Tag from "@insite/mobius/Icons/Tag";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

listStyles.cardList = mergeToNew(listStyles.cardList, {
    gridContainer: {
        gap: 0,
        css: css`
            margin-top: 16px;
        `,
    },
});

listStyles.wishListCard = mergeToNew(listStyles.wishListCard, {
    actionAddToCartButton: {
        color: themeColors.primary.danaBlue,
        css: css`
            padding: 8px 24px;
        `,
    },
    detailLinkGridItem: {
        css: css`
            [data-test-selector="wishListCardName"] {
                font-size: ${fontSizes.large};
                line-height: ${lineHeights.large};
                margin-top: -2px;
            }
        `,
    },
    sharingStatus: {
        statusText: {
            css: css`
                display: flex;
                align-items: center;
                column-gap: 4px;
            `,
        },
    },
    actionOverflowMenu: {
        buttonProps: {
            css: css`
                background: transparent;
                align-items: center;
                height: 32px;
                min-height: 32px;
                margin-top: -5px;
                &[class*="ButtonWrapper"] {
                    width: 32px;
                }
                [class*="IconWrapper"] {
                    top: 0;
                }
            `,
        },
        cssOverrides: {
            menuItem: css`
                &:hover {
                    background: ${themeColors.primary.danaBlue};
                    color: ${themeColors.primary.white};
                }
            `,
        },
    },
    wishListInfoGridItem: {
        width: [10, 10, 8, 9, 9],
    },
    actionGridItem: {
        width: [2, 2, 4, 3, 3],
    },
    basicIconGridContainer: {
        css: css`
            width: 24px;
        `,
    },
    detailIconGridItem: {
        css: css`
            max-width: 20px;
            flex-basis: 20px;
        `
    },
    actionFavoriteClickable: {
        css: css`
            width: 20px;
        `,
    },
    starIcon: {
        size: 20,
    },
    starXIcon: {
        size: 20,
    },
    tagTooltip: {
        iconProps: {
            size: 20,
        },
        cssOverrides: {
            tooltipBody: css`
                font-weight: ${fontWeights.regular};
                width: 100%;
            `,
            tooltipContainer: css`
                right: auto; 
                left: -16px;
                transform: translateX(16px);
                margin-bottom: 6px;
            `,
            tooltipArrow: css`
                right: auto; 
                left: 22px;
                transform: translateX(-18px);
            `
        },
    },
});

listStyles.cardContainer = mergeToNew(listStyles.cardContainer, {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            padding: 20px 0;
            > div {
                padding-left: 0;
                padding-right: 0;
            }
        `
    }
})